"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var _ObjectRecordAccessors = require("customer-data-objects/record/ObjectRecordAccessors");

var TaskPlaylistRecord =
/*#__PURE__*/
function (_Record) {
  (0, _inherits2.default)(TaskPlaylistRecord, _Record);

  function TaskPlaylistRecord() {
    (0, _classCallCheck2.default)(this, TaskPlaylistRecord);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TaskPlaylistRecord).apply(this, arguments));
  }

  (0, _createClass2.default)(TaskPlaylistRecord, [{
    key: "getQueueId",
    value: function getQueueId() {
      return this.getIn(['activeQueue', 'id'], null);
    }
  }, {
    key: "getTotalRemainingTasks",
    value: function getTotalRemainingTasks() {
      if (this.activeQueue) {
        return this.getRemainingTasks().size;
      }

      return this.totalFromQuery - this.nextTaskOffset;
    }
  }, {
    key: "getRemainingTasks",
    value: function getRemainingTasks() {
      if (!this.nextTask) {
        return (0, _immutable.List)();
      }

      var nextTaskIndex = this.tasks.indexOf(this.nextTask);
      return nextTaskIndex === -1 ? (0, _immutable.List)() : this.tasks.slice(nextTaskIndex, this.tasks.size);
    }
  }, {
    key: "isActiveTaskComplete",
    value: function isActiveTaskComplete() {
      return this.getIn(['activeTask', 'metadata', 'status']) === 'COMPLETED';
    }
  }, {
    key: "isWorkingOnLastTask",
    value: function isWorkingOnLastTask() {
      return !this.nextTask && !this.isActiveTaskComplete();
    }
  }, {
    key: "hasCompletedLastTask",
    value: function hasCompletedLastTask() {
      return !this.nextTask && this.isActiveTaskComplete();
    }
  }, {
    key: "getTaskIdAfterNextTask",
    value: function getTaskIdAfterNextTask() {
      if (!this.nextTask) {
        return null;
      }

      var nextTaskId = (0, _ObjectRecordAccessors.getId)(this.nextTask);

      if (!nextTaskId || this.tasks.size <= 1) {
        return null;
      }

      var nextTaskIdIndex = this.tasks.findIndex(function (task) {
        return "" + task.getIn(['engagement', 'id']) === "" + nextTaskId;
      });
      var nextNextTask = this.tasks.get(nextTaskIdIndex + 1);

      if (!nextNextTask) {
        return null;
      }

      return (0, _ObjectRecordAccessors.getId)(nextNextTask);
    }
  }]);
  return TaskPlaylistRecord;
}((0, _immutable.Record)({
  activeQueue: null,
  tasks: (0, _immutable.List)(),
  activeTask: null,
  nextTask: null,
  interaction: null,
  hasMoreTasks: false,
  nextTaskOffset: null,
  title: null,
  totalFromQuery: null,
  redirectUrl: null
}, 'TaskPlaylistRecord'));

exports.default = TaskPlaylistRecord;
module.exports = exports.default;